import "./FilterList.scss";

import React, { Component } from "react";
import {
  getLocal,
  getSession,
  setLocal,
  setSession,
} from "../../utils/localStorageCache";

import { DashboardList } from "../../config/dashboards";
import { DataLoader } from "../../ui-components/DataLoader/DataLoader";
import { DbrdUtils } from "../../chart-components/ChartUtils/DbrdUtils";
import { FilterMap } from "../FilterMap/FilterMap";
import Icon from "../Icon/Icon";
import { Loader } from "../../ui-components/Loader/Loader";
import PropTypes from "prop-types";
import { selectableLayers } from "../Map/selectableLayers";
import { toast } from "react-toastify";
import withRouter from "../../hocs/withRouter";
import FilterItem from "../FilterItem/FilterItem";

class FilterListBase extends Component {
  static propTypes = {
    match: PropTypes.any,
  };

  subscriptions = [];

  constructor(props) {
    super(props);

    // Get the dashboard fragment
    let dashboard = this.props.params.dashboard;

    // Set selection layer to null *not* undefined.
    let selectionLayer = null;

    // Default number of geometries
    let numGeom = 1;

    // Get selection layer
    let dbrdClass = Array.isArray(DashboardList[dashboard])
      ? DashboardList[dashboard][0]
      : null;
    if (DbrdUtils.isDashboard(dbrdClass)) {
      selectionLayer = dbrdClass.dashboardSettings().selectableLayer;
      if (dbrdClass.dashboardSettings().hasOwnProperty("numGeom")) {
        numGeom = dbrdClass.dashboardSettings().numGeom;
      }
    }

    this.state = {
      dashboard: dashboard,
      dashboards: getLocal("dashboards", 1), // TODO set this to lower value
      passlines: getLocal("passlines", 1),
      locations: getLocal("locations", 720),
      municipalities: getLocal("municipalities", 720),
      interactionType: null,
      selectionLayer: selectionLayer,
      featureProperty: null,
      filterKey: null,
      filter: getSession("filter", 180) || {},
      numGeom: numGeom,
    };

    this.setFilter = this.setFilter.bind(this);
    this.getFilter = this.getFilter.bind(this);
    this.onDashboardChange = this.onDashboardChange.bind(this);
    this.getDashboardSettings = this.getDashboardSettings.bind(this);
    this.setMapInteraction = this.setMapInteraction.bind(this);
    this.loadData = this.loadData.bind(this);
  }

  componentDidMount() {
    this.loadData();
  }

  componentWillUnmount() {
    // Cancel async operations here
    if (Array.isArray(this.subscriptions)) {
      this.subscriptions.forEach((s) => {
        if (typeof s.abort === "function") {
          s.abort();
        }
      });
    }
  }

  loadData(reloadLayer = undefined) {
    const { dashboards, passlines, locations, municipalities } = this.state;

    if (!Array.isArray(dashboards) || dashboards.length === 0) {
      this.loadDashboards();
    }

    if (
      !Array.isArray(passlines) ||
      passlines.length === 0 ||
      reloadLayer === selectableLayers.passlines
    ) {
      this.loadPasslines();
    }

    if (
      !Array.isArray(locations) ||
      locations.length === 0 ||
      reloadLayer === selectableLayers.location
    ) {
      this.loadLocations();
    }

    if (
      !Array.isArray(municipalities) ||
      municipalities.length === 0 ||
      reloadLayer === selectableLayers.municipalities
    ) {
      this.loadMunicipalities();
    }
  }

  loadDashboards() {
    this.subscriptions.push(
      DataLoader.getDashboards().then((dashboards) => {
        setLocal("dashboards", dashboards);
        this.setState({ dashboards: dashboards });
      })
    );
  }

  loadMunicipalities() {
    this.subscriptions.push(
      DataLoader.getMunicipalities().then((municipalities) => {
        setLocal("municipalities", municipalities);
        this.setState({ municipalities: municipalities });
      })
    );
  }

  loadPasslines() {
    this.subscriptions.push(
      DataLoader.getPasslines().then((passlines) => {
        setLocal("passlines", passlines);
        this.setState({ passlines: passlines });
      })
    );
  }

  loadLocations() {
    this.subscriptions.push(
      DataLoader.getLocations().then((locations) => {
        setLocal("locations", locations);
        this.setState({ locations: locations });
      })
    );
  }

  resetFilterState() {
    this.setState({
      filter: {},
    });
  }

  onDashboardChange(selection, id) {
    const { dashboard } = this.state;
    const { navigate } = this.props;

    if (dashboard === selection.uri) {
      this.setState({
        dashboard: null,
        key: null,
        features: [],
        interactionType: null,
        selectionLayer: null,
        filter: {},
      });
      this.resetFilterState();
      navigate("/tallogstatistikk");
    } else {
      let dbrdClass = DashboardList[selection.uri][0];
      let selectionLayer = null;
      let numGeom = 1;
      if (DbrdUtils.isDashboard(dbrdClass)) {
        selectionLayer = dbrdClass.dashboardSettings().selectableLayer;
        if (dbrdClass.dashboardSettings().hasOwnProperty("numGeom")) {
          numGeom = dbrdClass.dashboardSettings().numGeom;
        }
      }

      this.setState({
        dashboard: selection.uri,
        key: id,
        features: [],
        interactionType: undefined,
        selectionLayer: selectionLayer || null, // Must be null
        filter: {},
        numGeom: numGeom,
      });
      this.resetFilterState();
      navigate(`/tallogstatistikk/${selection.uri}/filter`);
    }
  }

  getDashboardSettings() {
    const { dashboard } = this.state;

    if (!dashboard) {
      return;
    }

    let newState = {};
    let dbrdClass = DashboardList[dashboard][0];

    // Getting state from dashboard
    if (DbrdUtils.isDashboard(dbrdClass)) {
      newState = dbrdClass.dashboardSettings();
    } else {
      console.error(
        `There is still a dashboard (${dbrdClass.name}) that does not have embedded config`
      );
    }

    this.setState(newState);
  }

  showToast(errorComponent) {
    toast.warn(errorComponent, {
      autoClose: 10000,
    });
  }

  setFilter(updatedFilter, clearMapInteraction = false) {
    var { filter, numGeom } = this.state;
    var updatedState = {};

    updatedState.filter = Object.assign({}, filter);

    // If less geometries than permissible
    if (
      Array.isArray(filter["geom"]) &&
      filter["geom"].length < numGeom &&
      Array.isArray(updatedFilter["geom"])
    ) {
      // console.debug('Adding geometry to existing filter');
      updatedFilter["geom"].forEach((g) => {
        filter["geom"].push(g);
      });
      updatedFilter["geom"] = filter["geom"].slice(0);
    }

    if (typeof updatedFilter === "string") {
      throw new Error(
        "A method is trying to set filter with a key and a value rather than an object"
      );
    } else if (typeof updatedFilter === "object") {
      updatedState.filter = Object.assign(updatedState.filter, updatedFilter);
    }

    if (clearMapInteraction) {
      updatedState.interactionType = undefined;
      updatedState.selectionLayer = undefined;
      updatedState.selectionGeometry = undefined;
      updatedState.numGeom = undefined;
      updatedState.sticky = undefined;
    }

    this.setState(updatedState, () => {
      setSession("filter", this.state.filter);
    });
  }

  setMapInteraction(
    interactionType,
    selectionLayer = null,
    selectionGeometry = null,
    numGeom = 1,
    sticky = false
  ) {
    return this.setState(
      {
        interactionType,
        selectionLayer,
        selectionGeometry,
        numGeom,
        sticky,
        passline: undefined,
      },
      () => {
        // console.debug('Updated filter on setMapInteraction', this.state.filter, this.state.interactionType);
      }
    );
  }

  getFilter() {
    return this.state.filter;
  }

  render() {
    const {
      dashboard,
      dashboards,
      passlines,
      municipalities,
      locations,
      filter,
      interactionType,
      selectionLayer,
      selectionGeometry,
      featureProperty,
      filterKey,
      numGeom,
    } = this.state;

    var isLoading =
      !Array.isArray(passlines) ||
      !Array.isArray(locations) ||
      !Array.isArray(municipalities) ||
      !filter;

    return (
      <div>
        <div className="filter--map-container">
          {!isLoading && (
            <FilterMap
              setFilter={this.setFilter}
              filter={filter}
              numGeom={numGeom}
              passlines={passlines}
              locations={locations}
              municipalities={municipalities}
              interactionType={interactionType}
              selectionLayer={selectionLayer}
              selectionGeometry={selectionGeometry}
              featureProperty={featureProperty}
              filterKey={filterKey}
            />
          )}
        </div>
        <div className="filter--container">
          <div className="filter--content">
            {isLoading && <Loader hideMessage />}
            {!isLoading &&
              Array.isArray(dashboards) &&
              dashboards.map((currDbrd, currIdx) => {
                return (
                  <div
                    key={currIdx}
                    className={[
                      "filter-field",
                      dashboard === currDbrd.uri ? "active" : "",
                    ].join(" ")}
                  >
                    <div
                      className="dashboard-dropdowns"
                      key={currIdx}
                      onClick={() => this.onDashboardChange(currDbrd, currIdx)}
                    >
                      <span>{currDbrd.title}</span>
                      <Icon
                        name={
                          dashboard === currDbrd.uri
                            ? "chevron_up"
                            : "chevron_down"
                        }
                      />
                    </div>
                    {dashboard === currDbrd.uri && (
                      <div>
                        <FilterItem
                          key={`id:${currIdx}`}
                          dashboard={dashboard}
                          passlines={passlines}
                          locations={locations}
                          numGeom={numGeom}
                          municipalities={municipalities}
                          interactionType={interactionType}
                          filter={filter}
                          setFilter={this.setFilter}
                          setMapInteraction={this.setMapInteraction}
                          loadData={this.loadData}
                        />
                      </div>
                    )}
                  </div>
                );
              })}
          </div>
        </div>
      </div>
    );
  }
}

export const FilterList = withRouter(FilterListBase);

export default FilterList;
